import { Loader } from "Components/_Shared/Loader";
import { AdminRouting, getAdminUrl } from "Infrastructure/Utils/UrlUtils";
import { useEffect } from "react";

export const AdminClientContractsRedirect = () => {
  useEffect(() => {
    window.location.replace(getAdminUrl(AdminRouting.ClientContracts.path()));
  }, []);

  return <Loader />;
};
